
import { component } from '@/helpers/vueTyped';

interface ContentBackgroundProps {
  imageURL: string;
  width?: number;
}

export default component<ContentBackgroundProps>()({
  name: 'ContentBackground',

  props: {
    imageURL: {},
    width: {},
  },

  computed: {
    queryParams(): string {
      return this.width == null ? '' : `?width=${this.width}`;
    },

    style(): string {
      return this.imageURL ? `background-image: url('${this.imageURL}${this.queryParams}');` : '';
    },
  },

  render() {
    return(
      <div class='bg-container'>
        <div class='bg-image' style={this.style} />
        <div class='bg-shadow'>
          {this.$slots.shadow}
        </div>
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-0b2984e5/ContentBackground.vue" });